import { AppState } from '@portal/app/store/app.state';

export const selectStore = (state: AppState) => state;
